import { BaseAnalysisEngine, BaseAnalysisResult } from "./baseAnalysisEngine";
import { ReactElement } from "react";
import { Box, Text } from "@chakra-ui/react";
import {
  ApiEngineType,
  ResultDashboardMciData,
  ResultMainParam,
} from "../types";

import { ResultError } from "../components/atoms/InnerPage/ResultError";

import resultGradationColorImageUrl from "/src/assets/images/mci/result_gradation_color.png";
import resultFaceiconGoodImageUrl from "/src/assets/images/mci/result_faceicon_good.png";
import resultFaceiconBadImageUrl from "/src/assets/images/mci/result_faceicon_bad.png";

type AnalysisResult = BaseAnalysisResult & {
  mci_threshold: number;
  mci_score: number;
};

const DEFAULT_DASHBOARD_MAIN_PARAM: ResultMainParam = {
  title: "Result.MCIMOSYS_vitality",
  border: "solid 3px #EFB6CB",
  value: undefined,
};

const ERROR_DASHBOARD_DATA: ResultDashboardMciData = {
  mainParam: DEFAULT_DASHBOARD_MAIN_PARAM,
  threshold: undefined,
};

/*
 * グラデーションバーの上部に表示する
 */
function Marker(props: Readonly<{ progress: number }>): ReactElement {
  return (
    <Box
      marginBottom="4px"
      position="absolute"
      left={`${props.progress}%`}
      bottom="100%"
      width={0}
      height={0}
      borderLeft="9px solid transparent"
      borderRight="9px solid transparent"
      borderTop="14px solid #404040"
      transform="translateX(-50%)"
    />
  );
}

export class MciEngine extends BaseAnalysisEngine<AnalysisResult> {
  _resultCaches: Record<string, AnalysisResult> = {};
  _engineType: ApiEngineType = "mci";
  _apiPath = "/analysis/mci";
  // _apiPath = "/error_401";

  private static convertToDashboardData(
    result: AnalysisResult
  ): ResultDashboardMciData {
    const mainParam: ResultMainParam = {
      ...DEFAULT_DASHBOARD_MAIN_PARAM,
      //      value: Math.round(result.mci_score * 100),
      value: result.mci_score,
    };
    const threshold = result.mci_threshold;

    return {
      mainParam,
      threshold,
    };
  }

  async renderResult(key: number, fileId: string): Promise<ReactElement> {
    const result = await this.getResult(fileId);
    // console.log("result:" + JSON.stringify(result,null,'\t'));

    const dashboardData = result
      ? MciEngine.convertToDashboardData(result)
      : ERROR_DASHBOARD_DATA;

    let result_status;
    let result_value = 0;
    if (typeof dashboardData.mainParam.value === "number") {
      const score_data = dashboardData.mainParam.value;
      console.log("score_data:" + JSON.stringify(score_data, null, "\t"));
      if (score_data == -1 || !dashboardData.threshold) {
        // 解析失敗時のスコアは-1
        result_status = "";
        if (!dashboardData.threshold) {
          console.log("mci_threshold is undefined");
        }
      } else {
        result_status = score_data > dashboardData.threshold ? "good" : "bad";
      }
      result_value = Math.round(dashboardData.mainParam.value * 100);
    }

    return (
      <Box key={key}>
        {result_status && (
          <Box
            sx={{
              ".result_title": {
                marginTop: "0.5em",
                fontSize: "30px",
              },
              ".result_text_summary": {
                marginTop: "0.5em",
                marginBottom: "0.5em",
                fontSize: "40px",
              },
              ".result_faceicon": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "1.5em",
              },
              ".result_faceicon img": {
                width: "60%",
              },
              "@media (max-width: 599px)": {
                ".result_text_summary": {
                  marginTop: "0.4em",
                  marginBottom: "0.5em",
                  fontSize: "30px",
                },
                ".result_faceicon": {
                  marginBottom: "1.5em",
                },
                ".result_faceicon img": {
                  width: "50%",
                },
              },
            }}
          >
            <Box className="result_text_summary">
              {result_status === "good" && <Text textAlign="center">正常</Text>}
              {result_status === "bad" && (
                <Text textAlign="center" color="#EB4143">
                  要注意
                </Text>
              )}
            </Box>
            <Box className="result_gradation">
              <Box position="relative">
                <img
                  className="record_sample_img_01"
                  src={resultGradationColorImageUrl}
                  alt=""
                />
                <Marker progress={result_value} />
              </Box>
            </Box>
            <Box className="result_faceicon">
              {result_status === "good" && (
                <img
                  className="record_sample_img_01"
                  src={resultFaceiconGoodImageUrl}
                  alt=""
                />
              )}
              {result_status === "bad" && (
                <img
                  className="record_sample_img_01"
                  src={resultFaceiconBadImageUrl}
                  alt=""
                />
              )}
            </Box>
          </Box>
        )}
        {!result_status && (
          <Box>
            <ResultError />
          </Box>
        )}
      </Box>
    );
  }
}
